import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsSearchWrapper = styled<any, any>(
    'div',
    'documentsSearchWrapper',
    'documentsGrid'
)`
    ${propStyles};
`;

DocumentsSearchWrapper.defaultProps = {
    padding: 'md',
};

export default DocumentsSearchWrapper;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsSearchWrapper.tsx